/**
 * Created by asiulik on 29.11.2017.
 */

define(function(){

    return {
        filtersSelector: ".filters",
        defaultFilterHeaderSelector: '.filters__header',
        filtersHeaderMobileSelector: '.filter__header__mobile',
        defaultFilterContentSelector: '.filters__content',
        filterHeaderItemSelector: '[data-filter-tag]',
        filterHeaderItemTagAttr: 'data-filter-tag',
        filterHeaderItemActiveClass: 'filter__button--active',
        filterElementSelector: "[data-tags]",
        filterElementTagAttr: "data-tags",
        filterElementHiddenClass: "filter__item--hidden",
        filterElementVisibleClass: "filter__item--visible",
        filterPreloaderSelector: ".filter__preloader",
        filterPreloaderActiveClass: "filter__preloader--active",
        filterLoadMoreSelector: "[data-filter-more]"
    };

});



// WEBPACK FOOTER //
// ./Private/Scripts/modules/filters/filterConfig.js